// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers, headers2, PROD_SSR_GQL_ENDPOINT } from '../configs/constants';

const EMPREENDIMENTO_DETAIL_TIMEOUT_MS = 10000;

// requests
export async function cities_types(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            cidades {
                id
                nome
                id_estado
                url_foto
            }
            tipos {
                id
                nome
            }
        }
    `;
    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function categorias(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            categorias {
                id
                nome
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function get_estados(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            estados {
                id
                nome
                pais
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function allCaracteristicas(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            caracteristicas {
                id
                nome
                imovel
                condominio
            }
        }
    `;
     try {

const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

// Catálogo COMPLETO do tenant (todas as características de Gestão › Características),
// não só as usadas em imóvel publicado. Usa o arg `todas: true` da query pública.
export async function allCaracteristicasCatalogo(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            caracteristicas(todas: true) {
                id
                nome
                imovel
                condominio
            }
        }
    `;
    try {
        const data = await graphQLClient.request(query);
        return data;
    } catch (error) {
        return null;
    }
}

export async function allDatasEntrega(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            datas_entrega
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getCompany(nameCompany?: string, origin?: string, codsite?: number, mostrar_site?: boolean,prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const expandedQuery = gql`
        {
            empreendimentos(nome: ${JSON.stringify(nameCompany || '')} ${mostrar_site ? `,mostrar_site: ${mostrar_site}` : ''}) {
                id
                nome
                Estado
                Pais
                referencia
                endereco
                construtora
                cep
                id_estado
                id_cidade
                id_bairro
                cidade
                bairro
                latitude_longitude
                unidades
                unidades_andar
                torres
                andares
                tipos_emp_detalhes {
                    id
                    nome
                }
                categoria_empreendimento {
                    id_categoria
                    nome
                }
                caracteristicas_detalhes {
                    id
                    nome
                }
                mostrar_site
                destaque
                Destaque
                foto_360
                meta_description
                meta_keywords
                meta_title
                descricao
                situacao
                porcentagem_vendido
                porcetagem_praca_alimentacao
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                preco_min
                preco_max
                area_privativa_min
                area_privativa_max
                fotos {
                  id
                  descricao
                  posicao
                  categoria
                  destaque
                  id_empreendimento
                  tipo
                  banner
                  url_foto
                }
            }
        }
    `;

    const legacyQuery = gql`
        {
            empreendimentos(nome: ${JSON.stringify(nameCompany || '')} ${mostrar_site ? `,mostrar_site: ${mostrar_site}` : ''}) {
                id
                nome
                Estado
                Pais
                referencia
                endereco
                construtora
                cep
                id_estado
                id_cidade
                id_bairro
                latitude_longitude
                unidades
                unidades_andar
                torres
                andares
                mostrar_site
                destaque
                Destaque
                foto_360
                meta_description
                meta_keywords
                meta_title
                descricao
                situacao
                porcentagem_vendido
                porcetagem_praca_alimentacao
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                preco_min
                preco_max
                area_privativa_min
                area_privativa_max
                fotos {
                  id
                  descricao
                  posicao
                  categoria
                  destaque
                  id_empreendimento
                  tipo
                  banner
                  url_foto
                }
            }
        }
    `;

     try {
const data = await graphQLClient.request(expandedQuery);
        return data;
    } catch (error) {
        try {
            const data = await graphQLClient.request(legacyQuery);
            return data;
        } catch (legacyError) {
            return null;
        }
    }
}

export async function getCompanySearch(
    pagina: number,
    qtd_pag?: number,
    nome?: string,
    cidade?: string,
    bairro?: string,
    preco_min?: number,
    preco_max?: number,
    tipo?: number,
    origin?: string,
    codsite?: number,
    prodOrigin?: any,
    // Recorte fixo de empreendimentos (menu apontando pra uma seleção, ex.: /condominios?ids=1,2).
    // Vazio/ausente = listagem inteira, como sempre.
    ids?: number[]
): Promise<any> {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if (prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT
    else
        endpoint = '/api/gql'

    const graphQLClient =
        prodOrigin ?
            new GraphQLClient(endpoint, {
                headers: {
                    ...headers2,
                    dominion: typeof window !== 'undefined' ? window.location.origin : origin,
                    'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
                    codsite: codsite ? codsite : 0
                },
            }) : new GraphQLClient(endpoint, {
                headers: {
                    ...headers,
                    dominion: typeof window !== 'undefined' ? window.location.origin : origin,
                    'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
                    codsite: codsite ? codsite : 0
                },
            });

    const page = Number(pagina) > 0 ? Number(pagina) : 1;
    const perPage = Number(qtd_pag) > 0 ? Number(qtd_pag) : 12;
    // Só inteiros positivos entram na query: a lista vem de querystring (pode vir suja).
    const idsSelecionados = Array.isArray(ids)
        ? ids.map((value) => Number(value)).filter((value) => Number.isInteger(value) && value > 0)
        : [];

    const queryArgs = `
                pagina: ${page},
                qtd_pag: ${perPage}
                ${nome ? `, nome: ${JSON.stringify(nome)}` : ''}
                ${cidade ? `, cidade: ${JSON.stringify(cidade)}` : ''}
                ${bairro ? `, bairro: ${JSON.stringify(bairro)}` : ''}
                ${typeof preco_min === 'number' ? `, preco_min: ${preco_min}` : ''}
                ${typeof preco_max === 'number' ? `, preco_max: ${preco_max}` : ''}
                ${typeof tipo === 'number' ? `, tipo: ${tipo}` : ''}
                ${idsSelecionados.length ? `, ids: [${idsSelecionados.join(', ')}]` : ''}
    `;

    const expandedQuery = gql`
        {
            empreendimentos_busca(
${queryArgs}
            ) {
                count
                empreendimentos {
                    id
                    nome
                    id_cidade
                    cidade
                    bairro
                    descricao
                    endereco
                    dormitorios
                    suites
                    vagas
                    id_tipos
                    tipos_emp
                    tipos_emp_detalhes {
                        id
                        nome
                        codsite
                    }
                    id_categoria
                    categoria_empreendimento {
                        id_categoria
                        nome
                        codsite
                    }
                    preco_min
                    preco_max
                    are_privativa_min
                    area_privativa_min
                    area_privativa_max
                    situacao
                    logo
                    urlAmigavel
                    mostrar_site
                    fotos {
                        id
                        url_foto
                        categoria
                        descricao
                        destaque
                    }
                }
            }
        }
    `;

    const legacyQuery = gql`
        {
            empreendimentos_busca(
${queryArgs}
            ) {
                count
                empreendimentos {
                    id
                    nome
                    id_cidade
                    cidade
                    bairro
                    id_tipos
                    tipos_emp
                    tipos_emp_detalhes {
                        id
                        nome
                        codsite
                    }
                    id_categoria
                    categoria_empreendimento {
                        id_categoria
                        nome
                        codsite
                    }
                    preco_min
                    preco_max
                    are_privativa_min
                    area_privativa_min
                    area_privativa_max
                    situacao
                    logo
                    urlAmigavel
                    mostrar_site
                    fotos {
                        id
                        url_foto
                        categoria
                    }
                }
            }
        }
    `;

    try {
        const expandedData = await graphQLClient.request(expandedQuery);
        return expandedData;
    } catch (error) {
        try {
            const legacyData = await graphQLClient.request(legacyQuery);
            return legacyData;
        } catch (legacyError) {
            return null;
        }
    }
}

export async function getEmpreendimentoById(
    id: number,
    origin?: string,
    codsite?: number,
    prodOrigin?: any
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const empreendimentoId = Number(id);
    if (!Number.isFinite(empreendimentoId) || empreendimentoId <= 0) {
        return null;
    }

    const isServerRequest = typeof window === 'undefined';
    const endpoint = isServerRequest && prodOrigin
        ? (PROD_SSR_GQL_ENDPOINT)
        : '/api/gql';

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...(isServerRequest && prodOrigin ? headers2 : headers),
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `empreendimento_specific_${empreendimentoId}`
        },
    });

    const expandedQuery = gql`
        {
            empreendimento(id: ${empreendimentoId}) {
                id
                nome
                id_tipos
                endereco
                cep
                Estado
                id_estado
                bairro
                cidade
                uf
                caracteristicas_detalhes {
                    id
                    nome
                }
                tipos_emp_detalhes {
                    id
                    nome
                }
                categoria_empreendimento {
                    id_categoria
                    nome
                }
                construtora
                descricao
                Descricao_interna
                situacao
                preco_min
                preco_max
                are_privativa_min
                area_privativa_min
                area_privativa_max
                dormitorios
                suites
                banheiros
                vagas
                unidades
                torres
                andares
                mostrar_site
                meta_description
                meta_keywords
                meta_title
                urlAmigavel
                siteEmpreendimento
                foto_destaque
                VideosEmpre
                latitude_longitude
                porcentagem_vendido
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                fotos {
                    id
                    descricao
                    posicao
                    categoria
                    destaque
                    id_empreendimento
                    tipo
                    banner
                    url_foto
                }
            }
        }
    `;

    const legacyQuery = gql`
        {
            empreendimento(id: ${empreendimentoId}) {
                id
                nome
                id_tipos
                endereco
                cep
                bairro
                cidade
                uf
                construtora
                descricao
                Descricao_interna
                situacao
                preco_min
                preco_max
                are_privativa_min
                area_privativa_min
                area_privativa_max
                dormitorios
                suites
                banheiros
                vagas
                unidades
                torres
                andares
                mostrar_site
                meta_description
                meta_keywords
                meta_title
                urlAmigavel
                siteEmpreendimento
                VideosEmpre
                latitude_longitude
                porcentagem_vendido
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                fotos {
                    id
                    descricao
                    posicao
                    categoria
                    destaque
                    id_empreendimento
                    tipo
                    banner
                    url_foto
                }
            }
        }
    `;

    const requestWithTimeout = async (document: string) => {
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const timeoutId = controller
            ? setTimeout(() => controller.abort(), EMPREENDIMENTO_DETAIL_TIMEOUT_MS)
            : null;

        try {
            if (!controller) {
                return await graphQLClient.request(document);
            }

            return await graphQLClient.request({
                document,
                signal: controller.signal
            } as any);
        } finally {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        }
    };

    try {
        const data = await requestWithTimeout(expandedQuery);
        return data;
    } catch (error) {
        try {
            const data = await requestWithTimeout(legacyQuery);
            return data;
        } catch (legacyError) {
            return null;
        }
    }
}

export async function getCompany_rodape(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            rodape {
                tipo
                cidade
                bairro
                dormitorios
                aluguel
                venda
                empreendimento
            }
        }
    `;

     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function district(idCity: number, origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });
    const query = gql`
        {
            bairros(id_cidade: ${idCity}) {
                id
                nome
                id_cidade
            }
        }
    `;

     try {
        
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getFilterPrices(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            precos_locacao {
                min
                max
            }
            precos_venda {
                min
                max
            }
        }
    `;

     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

/**
 * Ids dos empreendimentos que TÊM imóvel publicado na categoria (filtro
 * `com_imovel_categoria` do site-graphql). Usado pela vitrine de lançamentos da
 * home (cs2619): o carrossel de empreendimentos passa a casar com o mesmo
 * recorte da busca por categoria. SSR-only (prodOrigin obrigatório).
 */
export async function getEmpreendimentosIdsPorCategoria(
    origin: string | undefined,
    codsite: number | undefined,
    categoria: number,
    prodOrigin: any,
): Promise<number[] | null> {
    if (!prodOrigin || !categoria) return null;
    const graphQLClient = new GraphQLClient(PROD_SSR_GQL_ENDPOINT, {
        headers: {
            ...headers2,
            dominion: origin,
            'x-graphql-client-name': origin,
            codsite: codsite ? codsite : 0,
        },
    });
    try {
        const data: any = await graphQLClient.request(gql`
            { empreendimentos(com_imovel_categoria: ${Number(categoria)}) { id } }
        `);
        return (data?.empreendimentos || [])
            .map((e: any) => Number(e?.id))
            .filter((n: number) => Number.isFinite(n) && n > 0);
    } catch {
        return null; // falha = SEM recorte (vitrine degrada pro comportamento atual); [] legítimo = tenant sem lançamento
    }
}

/**
 * INC-0089 (cs604 Place Imóveis, 22/09/2026): lista ENXUTA dos empreendimentos que têm imóvel
 * publicado com o tipo / cidade / bairros escolhidos na busca — o select de Condomínio passa a
 * ser "eliminatório" em relação aos outros campos. `mostrar_site: true` é o MESMO recorte da lista
 * completa que a home recebe do SSR (loadCompanies), então o resultado é sempre um subconjunto do
 * que o visitante já via. Só pede os campos que `formatSelects` consome.
 * Devolve null em erro ou resposta inesperada (o chamador cai para a lista completa).
 */
export async function getCompanyPorImovel(
    origin: string | undefined,
    codsite: number | undefined,
    filtros: { tipos?: Array<number | string>; cidade?: number | string | null; bairros?: Array<number | string> },
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }
    const soIds = (lista?: Array<number | string>) =>
        (lista || []).map(Number).filter((n) => Number.isInteger(n) && n > 0);
    const tipos = soIds(filtros?.tipos);
    const bairros = soIds(filtros?.bairros);
    const cidade = Number(filtros?.cidade) || 0;
    const args = ['mostrar_site: true'];
    if (tipos.length) args.push(`imovel_tipos: [${tipos.join(', ')}]`);
    if (cidade > 0) args.push(`imovel_cidade: ${cidade}`);
    if (bairros.length) args.push(`imovel_bairros: [${bairros.join(', ')}]`);

    const graphQLClient = new GraphQLClient(BASE_URL, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });
    const query = gql`
        {
            empreendimentos(${args.join(', ')}) {
                id
                nome
                id_estado
            }
        }
    `;
    try {
        const data: any = await graphQLClient.request(query);
        return Array.isArray(data?.empreendimentos) ? data : null;
    } catch (error) {
        return null;
    }
}
